import { fakerRU as faker } from '@faker-js/faker';
import { signInMock } from './auth';
import { devices } from './devices';

export const balanceMock = {
  Balance: 10_000,
  Id: faker.string.nanoid(),
  Transaction: {
    Operation: 1,
    Timestamp: new Date().toISOString(),
    Amount: 10_000,
    Properties: {
      purpose: 'manual-correct',
      desc: 'Бонусное начисление'
    }
  },
  UpdatedAt: new Date().toISOString()
};

export const subbscriptionsMock = devices.flatMap((device) => [
  {
    AccountId: signInMock.User.Id,
    DeviceId: device.Id,
    Id: faker.string.nanoid(),
    IsActive: true,
    PurchaseInfo: {
      Currency: 'RUB',
      PaymentType: 0,
      Price: 200,
      Dt: new Date().toISOString()
    },
    ServiceId: 'MONI_PRO_RU',
    Status: 1,
    Lock: false
  },
  {
    AccountId: signInMock.User.Id,
    DeviceId: device.Id,
    Id: faker.string.nanoid(),
    IsActive: true,
    PurchaseInfo: {
      Currency: 'RUB',
      PaymentType: 0,
      Price: 100,
      Dt: 1663845424892
    },
    ServiceId: 'MOBILE_APP_RU',
    Status: 1,
    Lock: false
  }
]);
